import { createContext } from 'react'

export interface AuthState {
  userId: string
  displayName: string
  accessToken: string
  /** Cached only to render the shell sensibly while offline — never to authorise a session (§8.3). */
  entitlement?: { tier: string; validUntil: number }
}

export interface AuthContextValue {
  auth: AuthState | null
  loading: boolean
  login(displayName: string): Promise<void>
  logout(): Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
